import { generateOrderNumber } from "./GenerateOrderNumber";

export const jsonToCSV = (data, columns) => {
  if (!data?.length) return "";

  const headers = columns?.map((col) => col.label);

  const rows = data?.map((item) =>
    columns?.map((col) => {
      const value = col.value(item);
      return `"${value ?? ""}"`;
    })
  );

  return [headers, ...rows]
    .map((row) => row.join(","))
    .join("\n");
};


export const downloadCSV = (csvString, fileName = "report.csv") => {
  const blob = new Blob([csvString], {
    type: "text/csv;charset=utf-8;",
  });

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.setAttribute("download", fileName);

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const formatAddress = (addresses) => {
  if (!addresses || !addresses.length) return "";

  const addr = addresses[0]; 

  return [
    addr.first_name,
    addr.last_name,
    addr.address,
    addr.address2,
    addr.city,
    addr.region,
    addr.country,
    addr.pincode,
    addr.phoneNumber,
  ]
    .filter(Boolean) 
    .join(", ");
};

export const orderCsvColumns = [
  {
    label: "Order ID",
    value: (item) => generateOrderNumber(item?.id),
  },
  {
    label: "Buyer Email",
    value: (item) => item.buyer?.email,
  },
  {
    label: "Buyer Address",
    value: (item) => formatAddress(item.buyer?.shipping_address),
  },
  {
    label: "Buyer Shipping Fee",
    value: (item) => Math.round(Number(item?.bid?.shipping_fee) || 0),
  },
  {
    label: "Buyer Processing Fee",
    value: (item) => Math.round(Number(item?.bid?.processing_fee) || 0),
  },
  {
    label: "Seller Email",
    value: (item) => item.seller?.email,
  },
  {
    label: "Seller Address",
    value: (item) => formatAddress(item.seller?.shipping_address),
  },
  {
    label: "Seller Shipping Fee",
    value: (item) => Math.round(Number(item?.seller_shipment_fee) || 0),
  },
  {
    label: "Seller Processing Fee",
    value: (item) => Math.round(Number(item?.auction?.transaction_fee) || 0),
  },
  {
    label: "Seller Payment Proc Fee",
    value: (item) => Math.round(Number(item?.auction?.processing_fee) || 0),
  },
  {
    label: "Product Name",
    value: (item) => item.product?.model,
  },
  {
    label: "Product Subtitle",
    value: (item) => item.product?.subtitle,
  },
  {
    label: "Product Style Id",
    value: (item) => item.product?.style_id,
  },
  // {
  //   label: "Price",
  //   value: (item) => Math.round(item.price || 0),
  // },
  {
    label: "Total Price",
    value: (item) => Math.round(item.totalprice || 0),
  },
  {
    label: "Status",
    value: (item) => item.status,
  },
  {
    label: "Delivered At",
    value: (item) =>
      item?.shipment?.delivered_at
        ? new Date(item.shipment.delivered_at).toLocaleString()
        : "",
  },
];